import React, {useEffect, useState} from 'react'
import back1 from "../../../assets/images/image1.png"
import icon1 from "../../../assets/jobIcons/icon1.svg"
import datas from '../../../datas/Datas'
import JobCard from '../../../components/Cards/JobCard'
import SendEmailModal from '../../../../components/Modal/SendEmailModal'
import { About } from './partials/About'
import Offer from './partials/Offer'
import { TfiEmail } from 'react-icons/tfi'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { findCompany } from '../../../../redux/companySlice'
import ImageWithFallback from '../../../components/ImageWithFallback'
import { END_POINT } from '../../../../utils/constant'
import { FaBuilding, FaEnvelope, FaUsers, FaGlobe, FaMapMarkerAlt } from "react-icons/fa";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const RecruiterDetail = () => {
  const [jobs, setJobs] = useState(datas)
  const [showModal, setshowModal] = useState(false)
  const [option, setoption] = useState(1)
  const {id}= useParams()
  const item = []
  const jobDetail = [
    {
      icon:icon1,
      title: "Site Web",
      label: "http://haisoa.com",
    },
    {
      icon:icon1,
      title: "Email",
      label: "contact@haisoa.com",
    },
    {
      icon:icon1,
      title: "Téléphone",
      label: "024 47 555 97",
    },
    {
      icon:icon1,
      title: "Twiter",
      label: "hhhh@122",
    },
    {
      icon:icon1,
      title: "Type d'offre",
      label: "CDI",
    }
  ]

  // const { singleCompany, loading, error } = useSelector((state) => state.company);
  const dispatch = useDispatch()

  const { singleCompany, loading, error } = useSelector((state) => state.company);

  useEffect(() => {
    if (id) {
      dispatch(findCompany(id));
      // console.log(singleCompany)
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (singleCompany) {
      console.log("Données mises à jour :", singleCompany);
    }
  }, [singleCompany]);


  return (
    <>
    {/* <div className=" mb-6 rounded-lg h-56 mx-4 lg:mx-10 xl:mx-20 mt-10 bg-neutral-50" style={{backgroundImage: "url("+back1+")", objectFit: "cover", backgroundSize:"100%"}}>
 
    </div> 
    <div className="m-responsive rounded-md h-28 bg-white relative -mt-20 mb-10 rounded-40 border backdrop-shadow px-6 py-4 flex justify-between items-center">
      <div className="flex gap-4">
        <div className="  bg-gray-50 border rounded-md flex justify-center items-center w-28 h-20  overflow-hidden">
        <ImageWithFallback src={END_POINT+"/storage"+ singleCompany?.organisation_profile?.logo} className="  object-cover" defaultType="logo"/>
        </div>

          <div className="flex flex-col text-start justify-between py-2">
            <h1 className='text-2xl font-semibold'>{singleCompany?.organisation_profile?.company_name}</h1>
            <div className="inline-flex gap-1 text-sm text-primary-text"> {singleCompany?.organisation_profile?.address}</div>
          </div>        
      </div>
      

      <div className="flex gap-4">
      </div>
    </div> */}

<div
        className="mb-6 rounded-lg h-56 mx-4 lg:mx-10 xl:mx-20 mt-10 bg-neutral-50"
        style={{
          backgroundImage: loading
            ? "none"
            : `url(${back1})`,
          objectFit: "cover",
          backgroundSize: "100%",
        }}
      >
        {loading && (
          <Skeleton
            height="100%"
            width="100%"
            highlightColor="#fbfbfb"
            baseColor="#e9e9e9"
            style={{ borderRadius: "8px" }}
          />
        )}
      </div>

      {/* Carte entreprise */}
      <div className="m-responsive rounded-md h-28 bg-white relative -mt-20 mb-10 rounded-40 border backdrop-shadow px-6 py-4 flex justify-between items-center">
        <div className="flex gap-4">
          {/* Logo de l'entreprise */}
          <div className="bg-gray-50 border rounded-md flex justify-center items-center w-28 h-20 overflow-hidden">
            {loading ? (
              <Skeleton width={112} height={80} highlightColor="#fbfbfb" baseColor="#e9e9e9"/>
            ) : (
              <ImageWithFallback
                src={END_POINT + "/storage" + singleCompany?.organisation_profile?.logo}
                className="object-cover"
                defaultType="logo"
              />
            )}
          </div>

          {/* Nom et adresse */}
          <div className="flex flex-col text-start justify-between py-2">
            {loading ? (
              <>
                <Skeleton width={200} height={24}  highlightColor="#fbfbfb" baseColor="#e9e9e9"/>
                <Skeleton width={150} height={16}  highlightColor="#fbfbfb" baseColor="#e9e9e9"/>
              </>
            ) : (
              <>
                <h1 className="text-2xl font-semibold">
                  {singleCompany?.organisation_profile?.company_name}
                </h1>
                <div className="inline-flex gap-1 text-sm text-primary-text">
                  {singleCompany?.organisation_profile?.address}
                </div>
              </>
            )}
          </div>
        </div>

        {/* Bouton d'envoi d'email */}
        <div className="flex gap-4">
          {loading ? (
            <Skeleton width={180} height={40}  highlightColor="#fbfbfb" baseColor="#e9e9e9"/>
          ) : (
            <button
              onClick={() => setshowModal(true)}
              className="py-2 px-6 rounded-md bg-black text-white flex gap-1 items-center"
            >
              <TfiEmail /> Envoyer Un Mail
            </button>
          )}
        </div>
      </div>
    
    <div className=" mb-10 flex sticky top-0 border-b m-responsive my-4 text-sm bg-white pt-2">
      <button 
      onClick={()=>setoption(1)}
      className={" px-6 py-2 border-b-2 hover:text-primary-black " + (option === 2 ? "border-b-transparent text-primary-text font-normal" : "border-b-gray-950 text-primary-black font-bold")}>A propos</button>
      <button 
      onClick={()=>setoption(2)}
      className={" px-6 py-2 border-b-2 hover:text-primary-black " + (option === 1 ? "border-b-transparent text-primary-text font-normal" : "border-b-gray-950 text-primary-black font-bold")}>
        Offres ({singleCompany?.offers?.length})</button>    
    </div>

    <div className="p-responsive flex justify-between gap-10 mb-10">

        {/* Scrollable Content */}
        <div className="w-2/3 leading-loose text-justify text-black">
        
        {option === 1 ?
        <About item={singleCompany}/>
        :
        <Offer item={singleCompany?.offers}/>
        }
      
     </div>

     {/* Sticky Box */}
     <div className="w-1/3 h-fit bg-white border-2 border-gray-300 lg:block hidden rounded-2xl sticky top-20">
      <h5 className="text-xl font-semibold py-4 text-start px-6">Information Générale</h5>

      {/* Nom de l'entreprise */}
      <div className="border-b flex gap-4 items-center py-4 mx-6">
        <FaBuilding className="text-2xl text-primary" />
        <div className="flex flex-col text-start">
          <div className="text-sm text-primary-text">Nom</div>
          <div className="font-semibold">{singleCompany?.organisation_profile?.company_name || "N/A"}</div>
        </div>
      </div>

      {/* Email de contact */}
      <div className="border-b flex gap-4 items-center py-4 mx-6">
        <FaEnvelope className="text-2xl text-primary" />
        <div className="flex flex-col text-start">
          <div className="text-sm text-primary-text">Email</div>
          <div className="font-semibold">{singleCompany?.organisation_profile?.contact_email || "N/A"}</div>
        </div>
      </div>

      {/* Nombre d'employés */}
      <div className="border-b flex gap-4 items-center py-4 mx-6">
        <FaUsers className="text-2xl text-primary" />
        <div className="flex flex-col text-start">
          <div className="text-sm text-primary-text">Nombre d'employés</div>
          <div className="font-semibold">{singleCompany?.organisation_profile?.total_emloyees || "N/A"}</div>
        </div>
      </div>

      {/* Adresse */}
      <div className="border-b flex gap-4 items-center py-4 mx-6">
        <FaMapMarkerAlt className="text-2xl text-primary" />
        <div className="flex flex-col text-start">
          <div className="text-sm text-primary-text">Adresse</div>
          <div className="font-semibold">{singleCompany?.organisation_profile?.address || "N/A"}</div>
        </div>
      </div>

      {/* Site web */}
      <div className="border-b flex gap-4 items-center py-4 mx-6">
        <FaGlobe className="text-2xl text-primary" />
        <div className="flex flex-col text-start">
          <div className="text-sm text-primary-text">Site Web</div>
          <a
            href={singleCompany?.organisation_profile?.website_url}
            target="_blank"
            rel="noopener noreferrer"
            className="font-semibold text-blue-600 hover:underline"
          >
            {singleCompany?.organisation_profile?.website_url || "Aucun"}
          </a>
        </div>
      </div>
    </div>
      {/* <div className="w-1/3 h-[500px] bg-white  border-2 border-gray-300 rounded-2xl sticky top-20">
      <h5 className='text-xl font-semibold py-4 text-start px-6'>Contact</h5>
      {jobDetail.map((item)=>{
        return(
        <div className="border-b flex gap-4 items-center py-4 mx-6">
          <img src={item.icon} alt="..." />
          <div className="flex justify-between flex-col text-start">
            <div className='text-sm text-primary-text'>{item.title}</div>
            <div className='font-semibold'>{item.label}</div>
          </div>
        </div>  
        )
        })}
        <div className="w-full px-4">       
        </div>
      </div> */}

    </div>
  <SendEmailModal isOpen={showModal} onClose={()=>setshowModal(false)}></SendEmailModal>
  </>
  )
}

export default RecruiterDetail